import React from 'react';
import styles from '../../cases.module.scss';
import useSelectedLanguageCode from '../../../../../hooks/useSelectedLanguageCode';

const SuccessCaseTimeline = ({ successCases, index }) => {
    const selectedLanguageCode = useSelectedLanguageCode();

    const openCase = (caseId) => {
        document.getElementById(`case-${caseId}`).scrollIntoView()
    }

    return (
        <div className={styles.timeline}>
            <ul className={styles.timelineList}>
                {successCases?.map((sc, i) => (
                    <li
                        key={i}
                        className={`${styles.timelineItem} ${index === i ? styles.active : ''}`}
                        onClick={() => openCase(sc.id)}>
                        <span className={styles.timelineBullet}></span>
                        <span className={styles.timelineClientName}>{sc.clientName[selectedLanguageCode]}</span>
                    </li>
                ))}
            </ul>
        </div>
    );

};

export default SuccessCaseTimeline;
